<template>
    <div class="top20 bottom60">
        <dropper :index="index" :level="2"></dropper>
        <div v-if="$parent.editMode" class="delete is-pulled-right" @click="remove"></div>
        
        <div :class="{'top40': $parent.editMode}">
            <wideBundleDrop></wideBundleDrop>
        </div>
    </div>
</template>


<script>
import dropper from './sectionDropper.vue'
import colDrop from './colDrop.vue'
import wideBundleDrop from './wideBundleDrop.vue'
import { AZEventBus } from '../AZEventBus'

export default{
    props: {params: Object, index: Number},
    components: {dropper, colDrop, wideBundleDrop},
    data: function(){
        return {
            dirty: ''
        }
    },

    methods: {
        update: function(t){
          if(this.$refs[t].innerText != this.dirty){
            this.$parent.source[this.index].params.title = this.$refs[t].innerText
            this.$parent.source[this.index].params.text = this.$refs[t].innerText
            AZEventBus.$emit('pageChanged', null)
          } 
        },

        remove: function(){
            this.$parent.removeSection(this.index)
        },

        setDirty: function(t){
            this.dirty = this.$refs[t].innerText
        }
    }
}


</script>